import '../../../../external-libraries/highcharts/12.4.0/highcharts.js';
import '../../../../external-libraries/highcharts/12.4.0/modules/accessibility.js';

import DataVisualizationUtil from '../../dataVisualization/util.js';
import NeptuneElement from '../../NeptuneElement.js';

export class AreaChart extends NeptuneElement {

    templateMarkup = `
      <figure alt="Area chart"></figure>    
    `;

    componentCssUrl = '../chart.css';

    #chartContainer;
    #chartData = '[]';
    #chartSettings = '{}';

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['series', 'settings'];
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.validateRequiredProperties(['series']);
        this.processInitialAttributesAfterRender(AreaChart.observedAttributes);

        this.getChartColors = DataVisualizationUtil.getChartColors;
        this.normalizeSeriesData = DataVisualizationUtil.normalizeSeriesData;
        this.combineNamesWithSeries = DataVisualizationUtil.combineNamesWithSeries;
        this.#chartContainer = this.shadowRoot.querySelectorAll('figure')[0];
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (!this.isRendered) {
            return;
        }

        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {

        switch (name) {
            case 'series': {
                if ('' === newValue) {
                    return;
                }
                this.#chartData = newValue;
                break;
            }
            case 'settings': {
                if ('' === newValue) {
                    return;
                }
                this.#chartSettings = newValue;
                break;
            }
            default: {
                break;
            }
        }
        this.#renderChart();
    }

    /*
     Use setTimeout to give Highcharts enough time to calculate the container geometry and render
     itself including labels correctly.
     */
    #renderChart() {
        setTimeout(() => {
            this.#drawChart(this.#chartContainer, JSON.parse(this.#chartData), JSON.parse(this.#chartSettings));
        }, 100);
    }

    #drawChart(id, seriesData, chartSettings) {
        if ((undefined == seriesData) || ([] == seriesData)) {
            console.log('Neptune Area chart: No data');
            return;
        }

        if ((undefined == chartSettings) || ({} == chartSettings)) {
            chartSettings = {};
        }

        seriesData = this.normalizeSeriesData(seriesData);

        if (undefined != chartSettings?.seriesNames) {
            seriesData = this.combineNamesWithSeries(chartSettings.seriesNames, seriesData);
        }

        // eslint-disable-next-line
        return Highcharts.chart(id, {
            chart: {
                type: 'area'
            },
            colors: this.getChartColors(),
            title: {
                text: chartSettings?.title ?? ''
            },
            subtitle: {
                text: chartSettings?.subtitle ?? ''
            },
            xAxis: {
                categories: chartSettings?.categories,
                crosshair: true
            },
            yAxis: {
                title: {
                    text: chartSettings.yAxisTitle ?? ''
                }
            },
            tooltip: {
                enabled: true
            },
            plotOptions: {
                series: {
                    label: {
                        enabled: false
                    }
                }
            },
            legend: {
                enabled: chartSettings.showLegend ?? false
            },
            series: seriesData
        });
    }
}

customElements.define('neptune-area-chart', AreaChart);

export default {AreaChart};